/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getBirthHistories } from 'app/entities/birth-history/birth-history.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { Frequency } from 'app/shared/model/enumerations/frequency.model';
import { createEntity, getEntity, reset, updateEntity } from './apgar-score.reducer';

export const ApgarScoreUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const birthHistories = useAppSelector(state => state.birthHistory.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const apgarScoreEntity = useAppSelector(state => state.apgarScore.entity);
  const loading = useAppSelector(state => state.apgarScore.loading);
  const updating = useAppSelector(state => state.apgarScore.updating);
  const updateSuccess = useAppSelector(state => state.apgarScore.updateSuccess);
  const frequencyValues = Object.keys(Frequency);

  const handleClose = () => {
    navigate(`/apgar-score${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getBirthHistories({}));
    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.appearance !== undefined && typeof values.appearance !== 'number') {
      values.appearance = Number(values.appearance);
    }
    if (values.pulse !== undefined && typeof values.pulse !== 'number') {
      values.pulse = Number(values.pulse);
    }
    if (values.grimace !== undefined && typeof values.grimace !== 'number') {
      values.grimace = Number(values.grimace);
    }
    if (values.activity !== undefined && typeof values.activity !== 'number') {
      values.activity = Number(values.activity);
    }
    if (values.respiration !== undefined && typeof values.respiration !== 'number') {
      values.respiration = Number(values.respiration);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...apgarScoreEntity,
      ...values,
      birthHistory: birthHistories.find(it => it.id.toString() === values.birthHistory?.toString()),
      recordedBy: doctors.find(it => it.id.toString() === values.recordedBy?.toString()),
      recordedAt: hospitals.find(it => it.id.toString() === values.recordedAt?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          frequency: 'ONEMIN',
          ...apgarScoreEntity,
          birthHistory: apgarScoreEntity?.birthHistory?.id,
          recordedBy: apgarScoreEntity?.recordedBy?.id,
          recordedAt: apgarScoreEntity?.recordedAt?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.apgarScore.home.createOrEditLabel" data-cy="ApgarScoreCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.apgarScore.home.createOrEditLabel">Create or edit a ApgarScore</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="apgar-score-id"
                  label={translate('tinyMedicRestApp.apgarScore.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.appearance')}
                id="apgar-score-appearance"
                name="appearance"
                data-cy="appearance"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.pulse')}
                id="apgar-score-pulse"
                name="pulse"
                data-cy="pulse"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.grimace')}
                id="apgar-score-grimace"
                name="grimace"
                data-cy="grimace"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.activity')}
                id="apgar-score-activity"
                name="activity"
                data-cy="activity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.respiration')}
                id="apgar-score-respiration"
                name="respiration"
                data-cy="respiration"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.frequency')}
                id="apgar-score-frequency"
                name="frequency"
                data-cy="frequency"
                type="select"
              >
                {frequencyValues.map(frequency => (
                  <option value={frequency} key={frequency}>
                    {translate(`tinyMedicRestApp.Frequency.${frequency}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.active')}
                id="apgar-score-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.timestampentry')}
                id="apgar-score-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.microSec')}
                id="apgar-score-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.lastupdated')}
                id="apgar-score-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.apgarScore.cursor')}
                id="apgar-score-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="apgar-score-birthHistory"
                name="birthHistory"
                data-cy="birthHistory"
                label={translate('tinyMedicRestApp.apgarScore.birthHistory')}
                type="select"
                required
              >
                <option value="" key="0" />
                {birthHistories
                  ? birthHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="apgar-score-recordedBy"
                name="recordedBy"
                data-cy="recordedBy"
                label={translate('tinyMedicRestApp.apgarScore.recordedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="apgar-score-recordedAt"
                name="recordedAt"
                data-cy="recordedAt"
                label={translate('tinyMedicRestApp.apgarScore.recordedAt')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/apgar-score" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ApgarScoreUpdate;
